module.exports = __webpack_public_path__ + "static/media/3.64f3c86b.JPG";